import React from 'react';
import { SkeletonTable } from '../../components/Skeleton/Table';

const Loading: React.FC = () => (
  <SkeletonTable className="card-table" columns={4} rows={15} />
);

export default Loading;
